export default __webpack_public_path__ + "static/media/wayne_enterprises__earth-9925_.f948d1cc.png";